import { LoginForm } from '@/components/auth/LoginForm';

export function Login() {
  return <LoginForm />;
}